import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  background-color: var(--white);
  padding: 1rem;
  border: 1px solid var(--gray_light);
  border-radius: 0.4rem;
  width: 15.5rem;
  height: max-content;
  position: relative;
  cursor: pointer;

  a {
    display: flex;
    flex-direction: column;
  }

  a.product-unavailable {
    opacity: 0.7;

    .product-item-info > div {
      min-height: 6.9rem;
    }
  }

  .product-image {
    position: relative;
    width: 13rem;
    height: 13rem;
  }

  .product-image img:not(.Selo.UltraPremio) {
    margin-left: 1rem;
    width: 100%;
    height: 100%;
    max-width: 11rem;
    margin-bottom: 0.1rem;
    align-self: center;
    max-width: 11rem;
    max-height: 11rem;
  }

  .product-image.have-selo img:not(.Selo.UltraPremio) {
    margin-left: 1.5rem;
  }

  .product-item-tarjas {
    display: flex;
    flex-direction: column;
    height: 1.8rem;
    overflow: hidden;
  }

  .product-item-tarjas .tarjas {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    color: var(--white);
    font-weight: 700;
    font-size: 0.7rem;
    height: 1.9rem;

    & > *:not(:first-child) {
      display: none;
    }
  }

  .product-item-tarjas .frete-gratis-tarja {
    font-size: 0.9rem;
    background-color: var(--black);
  }

  .product-item-tarjas .ganhe-brinde-tarja {
    background-color: var(--green_blue);
  }

  .product-item-tarjas .red-tarja {
    background-color: var(--red);
  }

  .product-item-tarjas .promotion-tarja {
    width: 100%;
  }

  .frete-gratis-tag {
    position: absolute;
    top: 0.7rem;
    left: 0.5rem;
    z-index: 1;
    width: 6rem;
    border-radius: 0.4rem;
  }

  &.have-freight-free .icons-list {
    top: 2.4rem;
  }

  .tag-discount {
    top: 0.5rem;
    right: 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    max-width: 4rem;
    width: 4rem;
    height: 100%;
    max-height: 1.5rem;
    position: absolute;
    background-size: contain;
    background-image: url('/images/tag-discount.png');
    background-repeat: no-repeat;
    font-size: 1rem;
    font-weight: 800;
    color: var(--primary_color);
    padding-left: 0.4rem;
    user-select: none;
    z-index: 1;
  }

  .tag-novidade {
    position: absolute;
    top: 0.5rem;
    right: 1rem;
    padding: 0 0.1rem;
    font-weight: 700;
    color: var(--white);
    border-radius: 0.2rem;
    user-select: none;
    font-size: 0.9rem;
    background-color: var(--red);
    z-index: 1;
  }

  .icon.heart-icon,
  .trash-icon {
    cursor: pointer;
    width: 1.4rem;
    align-self: flex-end;
  }

  img.Selo.UltraPremio {
    display: none;
    position: absolute;
    top: 0;
    left: 0;
    max-width: 3rem;
  }

  .product-item-info {
    display: flex;
    flex-direction: column;
    position: relative;

    > div {
      height: 100%;
      min-height: 9rem;
    }

    .product-item-name {
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
      line-height: 1rem;
      font-size: 0.8rem;
      font-weight: 600;
      color: var(--black);
      padding: 0.2rem 0;
      height: 2.2rem;
    }

    .exclusive-product-item {
      height: 100%;
      display: flex;
      justify-content: center;
      flex-direction: column;
      font-size: 0.6rem;
      font-weight: 500;
      margin-top: 1rem;
    }

    .product-item-price-info {
      display: flex;
      flex-direction: column;

      .product-item-old-price-info,
      .product-item-new-price-info {
        width: 100%;
        max-width: max-content;
        font-size: 0.8rem;
        color: rgb(128, 128, 128);
        font-weight: 600;
        height: 1.4rem;

        .discount {
          margin-left: 0.4rem;
          font-weight: 500;
          padding: 0.2rem;
          font-weight: 700;
          color: var(--white);
          border-radius: 0.2rem;
          background-color: var(--red);
        }
      }

      .product-item-old-price-info {
        display: flex;
        align-items: center;
        margin-top: 0.2rem;
        margin-bottom: 0.1rem;
      }

      .product-item-price-for {
        font-size: 1.2rem;
        font-weight: 500;
        color: var(--primary_color);
        white-space: nowrap;
      }

      .product-item-price-unity-text {
        font-size: 0.8rem;
        color: var(--primary_color);
      }

      .product-item-price-unity {
        font-weight: 700;
        color: var(--red);

        span {
          color: rgb(64, 64, 64);
          font-weight: 400;
        }
      }

      .product-item-price-parcel {
        color: rgb(64, 64, 64);
        font-weight: 500;
        width: 100%;
      }

      .product-item-price-pix {
        display: flex;
        align-items: baseline;
        gap: 0.2rem;
        font-size: 0.75rem;

        b {
          font-size: 1.2rem;
          font-weight: 500;
          color: var(--primary_color);
          white-space: nowrap;
        }
      }

      .product-item-discount-parcel {
        display: flex;
        flex-direction: column;
        font-size: 0.75rem;
        font-weight: 500;
        color: rgb(89, 192, 11);
        height: 1rem;
      }
    }
  }

  .product-item-old-price-info .product-item-old-price {
    position: relative;
  }

  .product-item-x-price-old {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 100%;
    height: 100%;
    transform: translate(-50%, -50%);

    &::before {
      transform: translate(-50%, -50%) rotate(10deg);
    }

    &::after {
      transform: translate(-50%, -50%) rotate(-10deg);
    }

    &::before,
    &::after {
      content: '';
      position: absolute;
      width: 100%;
      height: 1px;
      background-color: var(--red);
      transform-origin: center;
      top: 50%;
      left: 50%;
    }
  }

  .product-item-button {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 0;
    margin-top: 0.4rem;
    min-height: 1.75rem;

    button {
      max-height: 1.2rem;
      min-height: 1.2rem;
    }

    #button-exclusive-product {
      background-color: var(--primary_color);
      border-color: var(--primary_color);
      align-self: flex-end;
    }

    #button-exclusive-product:hover,
    #button-send-me-email:hover {
      opacity: 0.8;
      color: var(--white);
    }

    #button-unavailable-product {
      opacity: 1;
      color: var(--black);
      background-color: var(--green_light);
      border-color: var(--green_light);
    }

    #button-send-me-email,
    #button-unavailable-product {
      font-size: 0.9rem;
      padding: 0.7rem 0;
    }
  }

  .product-item-group-buttons {
    display: grid;
    grid-template-areas:
      'item1 item2'
      'item3 item3';
    column-gap: 0.4rem;
    width: 100%;

    &.product-unavailable {
      display: flex;
      flex-direction: column;
      align-self: flex-end;
    }

    .item-counter {
      grid-area: item1;

      button {
        font-size: 1.4rem;
        width: 2.6rem;
        padding: 0;
      }

      input,
      .shopping-icon {
        width: 1.6rem;
      }

      .shopping-icon {
        height: 1.1rem;
      }
    }

    #button-buy {
      grid-area: item2;
      color: var(--black);
      border-color: var(--green_light);
      background-color: var(--green_light);
    }

    #button-add-to-cart {
      align-items: center;
      grid-area: item3;
      gap: 0.6rem;
    }

    #button-add-to-cart,
    #button-send-me-email {
      background-color: var(--black);
      border-color: var(--black);
      color: var(--green_light);
      margin-top: 0.4rem;
    }
  }

  .product-item-button #button-exclusive-product,
  .product-item-group-buttons.product-unavailable button {
    width: 100%;
  }

  @media (max-width: 768px) {
    .icons-list {
      display: none;
    }

    /* img.Selo.UltraPremio {
      display: inline-block;
    } */

    .product-image img,
    .product-image.have-selo img {
      margin-left: 0;
    }

    .product-item-info .product-item-price-info .product-item-discount-parcel {
      font-size: 0.7rem;
    }
  }

  @media (max-width: 520px) {
    width: 13.5rem;

    a.product-unavailable .product-item-info > div {
      min-height: 8.6rem;
    }

    .product-image {
      width: 9rem;
      height: 9rem;
    }

    .product-item-info .product-item-price-info .product-item-discount-parcel {
      font-size: 0.6rem;
    }

    .product-item-button {
      margin-top: auto;
      min-height: 3.7rem;
    }

    .product-item-group-buttons {
      grid-template-areas:
        'item1'
        'item2';
      row-gap: 0.4rem;

      #button-add-to-cart img {
        display: none;
      }

      .button-component,
      #button-send-me-email,
      #button-unavailable-product {
        font-size: 0.6rem;
        width: 100%;
        padding: 0.8rem 1.2rem;
        margin-top: 0;
      }
    }
  }

  @media (max-width: 470px) {
    .product-item-tarjas {
      height: 1.4rem;
    }

    .product-item-info .product-item-price-info .product-item-price-unity-text {
      font-size: 0.7rem;
    }

    .frete-gratis-tag {
      width: 4.3rem;
    }

    .tag-novidade {
      font-size: 0.7rem;
    }

    .cards-list-mobile {
      height: 2.2rem;
    }

    .product-item-tarjas .tarjas,
    .button-component {
      font-size: 0.5rem;
    }

    .product-item-group-buttons {
      grid-template-areas:
        'item1'
        'item2' !important;
    }
  }

  @media (max-width: 450px) {
    width: 100%;
    min-width: 0;

    .tag-discount,
    .tag-novidade {
      font-size: 0.7rem;
    }

    .tag-discount {
      width: 3rem;

      span {
        height: 1.2rem;
      }
    }

    .product-image.have-selo img:not(.Selo.UltraPremio) {
      height: 100%;
      margin-left: 0;
    }

    .product-item-tarjas {
      text-align: center;

      .frete-gratis-tarja {
        font-size: 0.8rem;
      }
    }

    .product-item-info .product-item-price-info .product-item-price-pix b {
      font-size: 1.1rem;
    }
  }

  @media (max-width: 380px) {
    .product-image {
      max-height: 7rem;

      img:not(.Selo.UltraPremio) {
        max-width: 7rem;
        max-height: 7rem;
        margin-left: 0;
      }
    }

    .cards-list-mobile {
      height: 1rem;

      img {
        max-height: 0.75rem;
      }
    }

    .tarjas {
      font-size: 0.4rem;
    }

    .product-item-info
      .product-item-price-info
      .product-item-old-price-info
      .discount {
      font-size: 0.6rem;
    }
  }

  @media (max-width: 370px) {
    .product-item-info .product-item-price-info .product-item-old-price-info,
    .product-item-info .product-item-price-info .product-item-new-price-info {
      font-size: 0.7rem;
      height: 1rem;
    }

    .product-item-info .product-item-price-info .product-item-price-pix b {
      font-size: 1rem;
    }
  }

  @media (max-width: 360px) {
    .product-item-info > div {
      min-height: 10rem;
    }

    .product-item-price-for {
      align-self: flex-start;
      font-size: 1rem;
    }
  }

  @media (max-width: 300px) {
    .product-image {
      max-height: 6rem;

      img:not(.Selo.UltraPremio) {
        max-width: 6rem;
        max-height: 6rem;
      }
    }

    .product-item-info
      .product-item-price-info
      .product-item-old-price-info
      .discount {
      font-size: 0.5rem;
    }
  }

  @media (max-width: 290px) {
    .product-item-info {
      > div {
        min-height: 11rem;
      }

      .product-item-price-info .product-item-old-price-info .discount {
        font-size: 0.5rem;
      }
    }
  }
`;
